// admin/src/lib/supabase.ts
//
// One Supabase client, same project as the app (VITE_SUPABASE_URL /
// VITE_SUPABASE_ANON_KEY -- see vite.config.ts for where those come
// from). Session persists in localStorage (the default), so a page
// reload keeps you signed in. Never import or reference a service-role
// key here: the anon key plus RLS/`is_admin()` is this site's entire
// security model.
import { createClient } from '@supabase/supabase-js';

export const SUPABASE_URL = import.meta.env.VITE_SUPABASE_URL;
export const SUPABASE_ANON_KEY = import.meta.env.VITE_SUPABASE_ANON_KEY;

if (!SUPABASE_URL || !SUPABASE_ANON_KEY) {
  // eslint-disable-next-line no-console
  console.warn(
    'VITE_SUPABASE_URL / VITE_SUPABASE_ANON_KEY are not set. Copy admin/.env.example to admin/.env.local, ' +
      'or set SUPABASE_URL/SUPABASE_ANON_KEY in the repo root .env -- see admin/README.md.',
  );
}

export const supabase = createClient(SUPABASE_URL || 'https://placeholder.supabase.co', SUPABASE_ANON_KEY || 'placeholder', {
  auth: {
    persistSession: true,
    autoRefreshToken: true,
    storageKey: 'calyard-admin-auth',
  },
});

export const MEDIA_BUCKET = 'exercise-media';
